<template>
  <v-app>
    <v-container fluid class="pa-0 fill-height d-flex" v-if="registering">
      <v-row no-gutters class="fill-height">
        <v-col cols="12" md="4" class="left-side d-flex justify-center">
          <h1 class="white--text main-title">
            Nossa metodologia, seu sucesso!
          </h1>
        </v-col>

        <v-col
          cols="12"
          md="8"
          class="right-side d-flex align-center justify-center"
        >
          <v-card class="form-card" elevation="0">
            <v-card-title class="d-flex align-center justify-center">
              <v-img
                src="@/assets/images/connect/customer/connect-logo.webp"
                contain
                height="250"
              ></v-img>
            </v-card-title>
            <v-card-text style="min-height: 55vh">
              <v-form
                ref="form"
                v-model="valid"
                elevation="0"
                @submit.prevent="nextStep"
              >
                <v-stepper
                  v-model="step"
                  class="stepper"
                  elevation="0"
                  style="max-width: 100%"
                >
                  <v-stepper-header
                    elevation="0"
                    class="d-flex align-center justify-center"
                  >
                    <span class="grey--text poppins">Let's do it!</span>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 1"
                      step="1"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 2"
                      step="2"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 3"
                      step="3"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 4"
                      step="4"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 5"
                      step="5"
                    ></v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items elevation="0">
                    <v-stepper-content step="1">
                      <v-card-text>
                        <h6 class="grey--text">1º Objetivo</h6>
                        <p class="mt-2">
                          <strong class="grey--text">A.</strong>
                          <strong class="primary900 poppins"
                            >Qual o seu objetivo para estudar inglês?</strong
                          ><br />
                          <span class="primary900"
                            >(Selecione a opção que melhor descreva a sua
                            situação)</span
                          >
                        </p>
                        <v-row dense>
                          <v-radio-group
                            v-model="form.details.mainGoal"
                            row
                            :rules="[(v) => !!v || 'Selecione uma opção.']"
                          >
                            <v-col cols="12" md="6">
                              <v-radio
                                label="Profissional"
                                value="PROFESSIONAL"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio
                                label="Comunicação"
                                value="COMMUNICATION"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio label="Viagens" value="TRIPS"></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio label="Outros" value="OTHERS"></v-radio>
                            </v-col>
                          </v-radio-group>
                        </v-row>
                      </v-card-text>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1">
                            <v-card-text>
                              <h6 class="grey--text">2º Acompanhamento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins"
                                  >Qual a sua preferência para estudar
                                  inglês?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 1"
                                  v-model="form.details.preference"
                                  column
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="Sozinho"
                                    value="ALONE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="Com Professor"
                                    value="WITH_TEACHER"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="2">
                            <v-card-text>
                              <h6 class="grey--text">2º Formato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins"
                                  >Quantas aulas por semana você gostaria de
                                  ter?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 2"
                                  v-model="form.details.perWeek"
                                  column
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="1"
                                    value="ONCE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="2"
                                    value="TWICE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="3+"
                                    value="THREE_OR_MORE"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">2º Formato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">C.</strong>
                                <strong class="primary900 poppins"
                                  >Qual modalidade de aula você deseja
                                  estudar?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="6"
                                  v-for="(goal, index) in types"
                                  :key="index"
                                  class="d-flex align-center justify-start"
                                >
                                  <v-checkbox
                                    v-if="step === 2 && subStep === 3"
                                    v-model="form.details.formatGoal"
                                    :value="goal.value"
                                    :label="goal.key"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row dense v-if="displayError">
                                <small style="color: #ea2626"
                                  >Selecione ao menos uma opção</small
                                >
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="4">
                            <v-card-text>
                              <h6 class="grey--text">2º Formato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">D.</strong>
                                <strong class="primary900 poppins"
                                  >Quantas horas por aula?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 4"
                                  v-model="form.details.availableHours"
                                  column
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="1:00"
                                    value="1:00"
                                  ></v-radio>

                                  <v-radio
                                    class="mt-1"
                                    label="1:30"
                                    value="1:30"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1" dense>
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Conhecimento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins"
                                  >Em uma escala de 0 a 10, qual é o seu grau de
                                  facilidade em compreender inglês em diversas
                                  situações?</strong
                                >
                              </p>
                              <v-row no-gutters align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Assistir filmes ou séries em inglês
                                    <strong style="color: #32352c">com</strong>
                                    legenda</span
                                  >
                                </v-col>
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    required
                                    row
                                    class="ml-3"
                                    v-model="form.details.watchWithSub"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Assistir filmes ou séries em inglês
                                    <strong style="color: #32352c">sem</strong>
                                    legenda</span
                                  > </v-col
                                ><v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="form.details.watchWithoutSub"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Entender uma conversa em inglês</span
                                  ></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="form.details.understanding"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4"
                                  ><span class="poppins grey--text"
                                    >Se comunicar em uma conversa em
                                    inglês</span
                                  ></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="form.details.communication"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text"
                                    >Ler um livro ou artigo em inglês</span
                                  ></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="form.details.reading"
                                    :rules="[
                                      (v) => !!v || 'Selecione uma opção.',
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="2">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Conhecimento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins"
                                  >Onde você geralmente tem contato com o inglês
                                  no seu dia a dia?</strong
                                >
                                <v-row dense class="mt-2">
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(learningWay, index) in learningWays"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      v-if="step === 3 && subStep === 2"
                                      v-model="form.details.mainContacts"
                                      :value="learningWay"
                                      :label="learningWay"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-row dense v-if="displayError">
                                  <small style="color: #ea2626"
                                    >Selecione ao menos uma opção</small
                                  >
                                </v-row>
                              </p>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Conhecimento</h6>
                              <p class="mt-2">
                                <strong class="grey--text">C.</strong>
                                <strong class="primary900 poppins"
                                  >Qual é a sua área de atuação
                                  atualmente?</strong
                                >
                              </p>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="4"
                                  v-for="(area, index) in currentAreas"
                                  class="d-flex align-center justify-start"
                                  :key="index"
                                >
                                  <v-checkbox
                                    v-model="form.details.currentAreas"
                                    :value="area"
                                    :label="area"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row dense v-if="displayError">
                                <small style="color: #ea2626"
                                  >Selecione ao menos uma opção</small
                                >
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="4">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">3º Objetivos</h6>
                              <p class="mt-2">
                                <strong class="grey--text">D.</strong>
                                <strong class="primary900 poppins"
                                  >Você tem alguma meta específica relacionada
                                  ao inglês que gostaria de compartilhar
                                  conosco?</strong
                                >
                              </p>
                              <v-col cols="12" md="9">
                                <v-textarea
                                  outlined
                                  solo
                                  placeholder="Digite sua mensagem."
                                  v-model="form.details.message"
                                  v-if="step === 3 && subStep === 4"
                                  rows="6"
                                ></v-textarea>
                              </v-col>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                      <v-card-text elevation="0">
                        <h6 class="grey--text">4º Disponibilidade</h6>
                        <p class="mt-2">
                          <strong class="grey--text">A.</strong>
                          <strong class="primary900 poppins"
                            >Informe TODOS os seus horários disponíveis na
                            semana para realizar as aulas</strong
                          >
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <WeeklyTable
                              ref="weeklyTable"
                              v-if="step === 4"
                              style="width: 100%"
                              :inAHalf="true"
                              :values="form.details.available"
                              :perClass="
                                toMinutes(form.details.availableHours) || 60
                              "
                          /></v-col>
                        </v-row>
                        <v-row dense align="center" justify="start">
                          <span v-if="hourAlert" style="color: crimson"
                            >Não são permitidos horários duplicados!</span
                          >
                        </v-row>
                      </v-card-text>
                    </v-stepper-content>
                    <v-stepper-content step="5">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">5º Contato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins"
                                  >Por favor, forneça as suas informações de
                                  contato e acesso:</strong
                                >
                              </p>
                              <v-row dense>
                                <v-col cols="12" md="8">
                                  <custom-input
                                    v-if="step === 5 && subStep === 1"
                                    required
                                    v-model="form.full_name"
                                    ref="nameInput"
                                    label="Nome Completo"
                                    placeholder="Nome Completo"
                                    hint="ex: Jhon Doe Schimit"
                                    :customRule="rules.full_name"
                                    :currentValue="form.full_name"
                                  ></custom-input>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <custom-masked-input
                                    v-if="step === 5 && subStep === 1"
                                    v-model="birthDate"
                                    label="Data de nascimento"
                                    placeholder="Dia/Mês/Ano"
                                    hint="ex: 25/12/2000"
                                    mask="##/##/####"
                                    :customRule="rules.validDate"
                                    :currentValue="birthDate"
                                  ></custom-masked-input>
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="12" md="6">
                                  <debounced-input
                                    v-if="step === 5 && subStep === 1"
                                    required
                                    v-model="form.email"
                                    ref="emailInput"
                                    label="Email"
                                    placeholder="Email"
                                    hint="ex: email@domain.com"
                                    :customRule="rules.email"
                                    :currentValue="form.email"
                                    :errorMessage="emailMessage"
                                    @search="checkEmail"
                                  ></debounced-input>
                                </v-col>
                                <v-col cols="12" md="2" class="pl-1">
                                  <custom-country-selector
                                    @onInput="(value) => (ddi = value)"
                                  />
                                </v-col>
                                <v-col cols="12" md="4" class="pl-1">
                                  <custom-masked-input
                                    v-if="step === 5 && subStep === 1"
                                    required
                                    v-model="form.phone"
                                    ref="emailInput"
                                    label="Telefone"
                                    placeholder="(99)12345-6789"
                                    hint="ex: (99)12345-6789"
                                    mask="(##)#####-####"
                                    :currentValue="form.phone"
                                  ></custom-masked-input>
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col cols="12" md="6">
                                  <custom-input
                                    v-if="step === 5 && subStep === 1"
                                    required
                                    v-model="form.password"
                                    class="mt-4"
                                    label="Senha"
                                    placeholder="Senha"
                                    :errorMessage="errorMessage"
                                    :type="showPassword ? 'text' : 'password'"
                                    :customRule="rules.password"
                                    :appendIcon="
                                      showPassword
                                        ? 'mdi-eye'
                                        : 'mdi-eye-closed'
                                    "
                                    @iconClick="showPassword = !showPassword"
                                  ></custom-input>
                                </v-col>
                                <v-col cols="12" md="6" class="pl-1">
                                  <custom-input
                                    v-if="step === 5 && subStep === 1"
                                    required
                                    v-model="password"
                                    class="mt-4"
                                    label="Confirmar senha"
                                    placeholder="Confirmar senha"
                                    :errorMessage="errorMessage"
                                    :type="showPassword ? 'text' : 'password'"
                                    :customRule="rules.password"
                                    :appendIcon="
                                      showPassword
                                        ? 'mdi-eye'
                                        : 'mdi-eye-closed'
                                    "
                                    @iconClick="showPassword = !showPassword"
                                  ></custom-input>
                                </v-col>
                              </v-row>
                              <v-row
                                dense
                                align="center"
                                justify="start"
                                v-if="!form.underAge && password"
                              >
                                <v-checkbox
                                  v-model="form.accepted_eula"
                                  v-if="step === 5 && subStep === 1"
                                >
                                  <template v-slot:label>
                                    <span
                                      >Ao confirmar você concorda com
                                      <a
                                        target="_blank"
                                        href="/termos"
                                        @click.stop
                                        >termos e condiçoes de uso.</a
                                      ></span
                                    >
                                  </template>
                                </v-checkbox>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>

                          <v-stepper-content step="2">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">5º Contato</h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins"
                                  >Por favor, informe os dados do responsável
                                  legal:</strong
                                >
                              </p>
                              <v-row dense> </v-row>
                              <div v-if="form.underAge">
                                <v-row dense class="mt-2">
                                  <v-col cols="12" md="6">
                                    <custom-input
                                      v-model="form.legalGuardian.name"
                                      v-if="
                                        step === 5 &&
                                        subStep === 2 &&
                                        form.underAge
                                      "
                                      label="Nome completo do responsável"
                                      placeholder="Informe o nome do seu responsável legal"
                                      :currentValue="form.legalGuardian.name"
                                      :customRule="rules.requiredField"
                                    ></custom-input>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <custom-input
                                      v-if="step === 5 && subStep === 2"
                                      required
                                      v-model="form.legalGuardian.email"
                                      ref="emailInput"
                                      label="Email"
                                      placeholder="Email"
                                      hint="ex: email@domain.com"
                                      :customRule="rules.email"
                                      :currentValue="form.legalGuardian.email"
                                    >
                                    </custom-input>
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="2">
                                    <custom-country-selector
                                      @onInput="
                                        (value) => (legalGuardianddi = value)
                                      "
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4" sm="6">
                                    <custom-masked-input
                                      v-if="
                                        step === 5 &&
                                        subStep === 2 &&
                                        form.underAge
                                      "
                                      v-model="form.legalGuardian.phone"
                                      label="Telefone do responsável"
                                      placeholder="(11)99999-9999"
                                      hint="ex: (11)1234-5678"
                                      :mask="'(##)#####-####'"
                                      :currentValue="form.legalGuardian.phone"
                                    ></custom-masked-input>
                                  </v-col>
                                  <v-col cols="12" md="6" sm="6">
                                    <custom-masked-input
                                      v-if="step === 5 && subStep === 2"
                                      v-model="form.legalGuardian.birthDate"
                                      label="Data de nascimento do responsável"
                                      placeholder="Dia/Mês/Ano"
                                      hint="ex: 25/12/1960"
                                      mask="##/##/####"
                                      :currentValue="
                                        form.legalGuardian.birthDate
                                      "
                                      :customRule="rules.validDate"
                                    ></custom-masked-input>
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="6">
                                    <custom-masked-input
                                      v-if="step === 5 && subStep === 2"
                                      v-model="form.legalGuardian.document"
                                      label="Número do documento do responsável"
                                      placeholder="123.456.789-10"
                                      mask="###.###.###-##"
                                      :currentValue="
                                        form.legalGuardian.document
                                      "
                                      :customRule="rules.document"
                                    ></custom-masked-input>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <div>Grau de parentesco</div>
                                    <div class="d-flex align-center">
                                      <v-select
                                        v-if="
                                          step === 5 &&
                                          subStep === 2 &&
                                          form.underAge
                                        "
                                        v-model="form.legalGuardian.kinship"
                                        chips
                                        dense
                                        required
                                        background-color="#F1F3F5"
                                        :rules="rules.required"
                                        :items="parentGrades"
                                        :item-value="`value`"
                                        :item-text="`text`"
                                        style="border-radius: 5px"
                                      ></v-select>
                                    </div>
                                  </v-col>
                                </v-row>
                                <v-row
                                  dense
                                  align="center"
                                  justify="start"
                                  v-if="form.underAge && subStep === 2"
                                >
                                  <v-checkbox v-model="form.accepted_eula">
                                    <template v-slot:label>
                                      <span
                                        >Ao confirmar você concorda com
                                        <a
                                          target="_blank"
                                          href="/termos"
                                          @click.stop
                                          >termos e condiçoes de uso.</a
                                        ></span
                                      >
                                    </template>
                                  </v-checkbox>
                                </v-row>
                              </div>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    outlined
                    @click="prevStep"
                    x-large
                    class="grey--text fill-width"
                    >Voltar</v-btn
                  >
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    @click="nextStep"
                    color="#b51f57"
                    x-large
                    class="white--text"
                    :loading="loading"
                    :disabled="keepDisabled"
                    >{{
                      (step === 5 && subStep === 2) ||
                      (step === 5 && !form.underAge)
                        ? "Concluir"
                        : "Avançar"
                    }}</v-btn
                  >
                </div>
              </v-col>
            </v-card-actions>
            <div class="d-flex align-center justify-center">
              <CopyRight />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <SuccessRegister module="customer" />
    </v-container>
  </v-app>
</template>

<script>
import { cpf } from "cpf-cnpj-validator";
import api from "@/shared/pitchCustomerApi";
import CopyRight from "@/components/CopyRight.vue";
import WeeklyTable from "@/components/connect/WeeklyTable.vue";
import { differenceInYears, isBefore, isValid, parse } from "date-fns";
import SuccessRegister from "@/components/connect/SuccessRegistered.vue";
export default {
  components: {
    CopyRight,
    WeeklyTable,
    SuccessRegister,
  },
  computed: {
    keepDisabled() {
      return this.step === 5 && this.subStep === 2 && !this.form.accepted_eula;
    },
  },
  data() {
    return {
      hourAlert: false,
      displayError: false,
      step: 1,
      subStep: 1,
      valid: false,
      showPassword: false,
      errorMessage: "",
      loading: false,
      registering: true,
      password: "",
      isUniqueEmail: false,
      emailMessage: null,
      birthDate: null,
      ddi: "55",
      legalGuardianddi: "55",
      form: {
        full_name: "",
        phone: "",
        email: "",
        password: "",
        accepted_eula: false,
        birthDate: null,
        underAge: true,
        details: {
          mainGoal: null,
          preference: null,
          perWeek: null,
          watchWithSub: null,
          watchWithoutSub: null,
          understanding: null,
          communication: null,
          reading: null,
          mainContacts: [],
          currentAreas: [],
          message: null,
          formatGoal: [],
          availableHours: null,
        },
        available: [
          {
            weekDay: null,
            from: null,
            to: null,
          },
        ],
        legalGuardian: {
          name: null,
          email: null,
          birthDate: null,
          document: null,
          kinship: null,
          phone: null,
        },
      },
      learningWays: [
        "Música",
        "Filmes e Séries",
        "Livros",
        "Estudos",
        "Trabalho",
        "Outras Formas",
        "Amigos",
        "Redes Sociais",
      ],
      currentAreas: [
        "Estudante",
        "Educação",
        "Comércio",
        "Tecnologia",
        "Saúde",
        "Outros",
      ],
      types: [
        { key: "Individual", value: "INDIVIDUAL" },
        { key: "Dupla", value: "DUO" },
        { key: "Trio", value: "TRIO" },
        { key: "Quarteto ", value: "SQUAD" },
      ],
      rules: {
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v) || "Email inválido.",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        required: [(v) => !!v || "Selecione uma opção."],
        requiredField: [(v) => !!v || "Campo obrigatório."],
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
        validDate: [(v) => this.validDate(v) || "Data de nascimento inválida."],
      },
      parentGrades: [
        { text: "Pai/Mãe", value: 1 },
        { text: "Padrasto/Madrasta", value: 2 },
        { text: "Tio/Tia", value: 3 },
        { text: "Avô/Avó", value: 4 },
        { text: "Responsável legal", value: 5 },
        { text: "Outro", value: 6 },
      ],
    };
  },
  methods: {
    verifyDuplicated(horarios) {
      const seen = new Set();
      let hasDuplicated = false;
      horarios.filter((horario) => {
        const chave = `${horario.weekDay}-${horario.from}-${horario.to}`;
        if (seen.has(chave)) {
          hasDuplicated = true;
          return true;
        }
        seen.add(chave);
        return false;
      });
      return hasDuplicated;
    },
    nextStep() {
      if (this.step === 4 && this.subStep === 1) {
        const items = this.$refs.weeklyTable.getData();
        console.log("data: ", items);
        if (items.length > 0 && items[0].weekDay !== null) {
          this.form.available = items;
          if (this.verifyDuplicated(items)) {
            this.hourAlert = true;
          } else {
            this.nextSubStep();
          }
        }
      } else if (
        // eslint-disable-next-line no-dupe-else-if
        this.step === 5 &&
        this.subStep === 2 &&
        this.$refs.form.validate()
      ) {
        this.submit();
      } else if (this.step === 2 && this.form.details.preference === "ALONE") {
        this.form.details.perWeek = 0;
        this.form.details.availableHours = 0;
        this.form.details.formatGoal = "ALONE";
        this.subStep = 1;
        this.step++;
      } else if (this.step === 2 || this.step === 3) {
        this.nextSubStep();
      } else if (this.step === 5 && this.subStep === 1) {
        if (this.$refs.form.validate()) {
          if (this.form.underAge) this.subStep++;
          else this.submit();
        }
      } else if (this.$refs.form.validate()) {
        this.step++;
      }
    },

    nextSubStep() {
      if (
        this.step === 2 &&
        this.subStep === 3 &&
        this.form.details.formatGoal.length === 0
      ) {
        this.displayError = true;
      } else if (
        this.step === 2 &&
        this.subStep < 5 &&
        this.$refs.form.validate()
      ) {
        this.displayError = false;
        this.subStep++;
      } else if (
        this.step === 3 &&
        this.subStep < 4 &&
        this.$refs.form.validate()
      ) {
        if (this.subStep === 2 && this.form.details.mainContacts.length === 0) {
          this.displayError = true;
          return;
        } else if (
          this.subStep === 3 &&
          this.form.details.currentAreas.length === 0
        ) {
          this.displayError = true;
          return;
        }
        this.displayError = false;
        this.subStep++;
      } else if (this.step === 4 && this.subStep === 1) {
        this.step++;
      } else {
        if (this.$refs.form.validate()) {
          this.subStep = 1;
          this.step++;
        }
      }
    },
    prevStep() {
      if (this.step > 1) {
        if (this.step === 3) {
          return this.previousSubStep();
        } else if (this.step === 4) return this.previousSubStep();
        else if (this.step === 2) {
          return this.previousSubStep();
        } else if (this.step === 5) {
          return this.previousSubStep();
        }
        this.step--;
      } else {
        this.$router.push({
          path: "/connect",
        });
      }
    },
    previousSubStep() {
      if (this.step === 3 && this.subStep === 1) {
        this.subStep = this.form.details.preference === "ALONE" ? 1 : 4;
        this.step--;
      } else if (this.step === 4 && this.subStep === 2) {
        this.subStep--;
      } else if (this.step === 4 && this.subStep === 1) {
        this.step--;
        this.subStep = 4;
      } else if (this.step === 2 && this.subStep < 5 && this.subStep > 1)
        this.subStep--;
      else if (this.step === 2 && this.subStep === 1) {
        this.step--;
      } else if (this.step === 3 && this.subStep < 7 && this.subStep > 1) {
        this.subStep--;
      } else if (this.step === 5 && this.subStep === 2) {
        this.subStep--;
      } else if (this.step === 5 && this.subStep === 1) {
        this.step--;
        this.subStep = 1;
      }
    },
    submit() {
      this.loading = true;
      if (this.form.underAge) {
        this.form.legalGuardian.phone =
          this.form.legalGuardian.phone.length > 9
            ? this.legalGuardianddi +
              this.form.legalGuardian.phone
                .replaceAll("(", "")
                .replaceAll(")", "")
                .replaceAll("-", "")
                .replaceAll("+", "")
            : this.form.legalGuardian.phone;
      }

      this.form.phone =
        this.form.phone.length > 9
          ? `${this.ddi}${this.form.phone
              .replaceAll("(", "")
              .replaceAll(")", "")
              .replaceAll("-", "")}`
          : this.form.phone;
      api
        .signUp(this.form)
        .then(() => {
          this.registering = false;
        })
        .catch(() => {
          this.loading = false;
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro inesperado, tente novamente mais tarde.",
            type: 1,
          });
        });
    },
    checkEmail(email) {
      api
        .validateEmail({ email })
        .then((res) => {
          if (res.data.result) this.emailMessage = "Email já registrado";
          else {
            this.emailMessage = "";
            this.isUniqueEmail = true;
          }
        })
        .catch(() => {
          this.emailMessage = "Email já está em uso.";
        });
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
    validDate(d) {
      const inputedDate = parse(d, "dd/MM/yyyy", new Date());
      return isValid(inputedDate) && isBefore(inputedDate, new Date());
    },
    toMinutes(classTime) {
      return classTime === "1:00" ? 60 : 90;
    },
  },
  watch: {
    subStep(value) {
      if (this.step === 2 && value === 5) {
        this.subStep = 1;
        this.step++;
      } else if (this.step === 3 && value === 7) {
        this.subStep = 1;
        this.step++;
      }
    },
    password(value) {
      if (value !== this.form.password) {
        this.errorMessage = "As senhas devem ser iguais.";
      } else {
        this.errorMessage = "";
      }
    },
    birthDate(value) {
      if (value) {
        try {
          const birthDate = parse(value, "dd/MM/yyyy", new Date());
          this.form.birthDate = birthDate;
          const difference = differenceInYears(new Date(), birthDate);
          if (difference < 18) {
            this.form.underAge = true;
          } else {
            this.form.underAge = false;
          }
        } catch (e) {
          return e;
        }
      }
    },
  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}

.left-side {
  background-image: url("../../../assets/images/connect/customer/background-min.webp");
  background-size: cover;
  background-position: center;
  color: white;

  h1 {
    margin-top: 15vh;
  }
}

.right-side {
  padding: 24px;
  display: flex;
}

.form-card {
  width: 100%;
  height: 100%;
}

.primary900 {
  color: #6b1233;
}

.primary700 {
  color: #b51f57;
}

strong {
  font-size: 16px;
}
</style>
